import IState from '@/interfaces/IState';
import {ActionContext} from 'vuex';

export default async (context: ActionContext<IState, IState>, downloadAppStatus: boolean) => {
    try {
        context.commit('uploadDownloadAppStatus', downloadAppStatus)
    } catch (err) {
        throw new Error(err);
    }
};
